// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7b067da2","796":"465dd19a"}[chunkId] + ".chunk.js";
};